export default defineNuxtRouteMiddleware((to, from) => {
	const { loggedIn } = useUserSession();

	if (!loggedIn.value) {
		return navigateTo('/?openLoginModal=true', { redirectCode: 401 });
	}
});
